// Todo: Align with design
import { defineRecipe } from '@chakra-ui/react';

export const textareaRecipe = defineRecipe({
  className: 'chakra-textarea',
  base: {
    width: '100%',
    minWidth: '0',
    position: 'relative',
    appearance: 'none',
    textAlign: 'start',
    borderRadius: 'l2',
    outline: 'none',
    outlineStyle: 'none',
    _disabled: {
      layerStyle: 'disabled',
    },
    '--error-color': 'colors.border.error',
    _invalid: {
      borderColor: 'border.error',
    },
    _focus: {
      outline: 'none',
    },
    _focusVisible: {
      outline: 'none',
    },
    _focusWithin: {
      outline: 'none',
    },
    _placeholder: {
      color: 'text.quaternary',
    },
  },
  variants: {
    size: {
      xs: {
        textStyle: 'xs',
        px: '2',
        py: '1.5',
        scrollPaddingBottom: '1.5',
      },
      sm: {
        textStyle: 'sm',
        px: '2.5',
        py: '2',
        scrollPaddingBottom: '2',
      },
      md: {
        textStyle: 'body.s.regular',
        px: '3',
        py: '2',
        scrollPaddingBottom: '2',
      },
      lg: {
        textStyle: 'md',
        px: '4',
        py: '3',
        scrollPaddingBottom: '3',
      },
      xl: {
        textStyle: 'md',
        px: '4.5',
        py: '3.5',
        scrollPaddingBottom: '3.5',
      },
      // tmp until we rework whole recipe - used by BlockInput component
      figma: {
        textStyle: 'h6.regular',
        py: 's',
        px: 's',
      },
    },

    variant: {
      outline: {
        borderWidth: '1px',
        bg: 'transparent',
      },
      subtle: {
        borderWidth: '1px',
        borderColor: 'transparent',
      },
    },
  },

  defaultVariants: {
    size: 'md',
    variant: 'outline',
  },
});
